<template>
  <list :dataSet="dataSet"></list>
</template>



<script>

import List from "@/views/Insights/List/List";

export default {
  name: "Tools",
  components: {List},
  data(){
    return{
      title:'Tools',
      dataSet:'tools'
    }
  },
  mounted() {
    document.title = this.title;

  }
}
</script>

<style scoped>

</style>